
import validator from 'validator';

const ValidateEditGeneral = (data) => {
    let errors = {};

    const { information_description} = data;

    if (validator.isEmpty(information_description)) {
        errors.information_description = '설명은 필수 입력 사항입니다.';
    }
    return {
        isInvalid: Object.keys(errors).length > 0,
        error: errors,
    };
};

export default ValidateEditGeneral;
